import { call, put, take, takeLatest } from 'redux-saga/effects'
import { eventChannel, END } from 'redux-saga'
import { ListingsTypes, ListingsActions } from './listingsSlice'
import api from '../../services/api'


function* createListingSaga(action) {
    const { formData } = action
    const response = yield call(api.createListing, formData)

    if (response.ok) {
        yield put(ListingsActions.createListingSuccess(response.data))
    } else {
        yield put(ListingsActions.createListingFailure(response.problem))
    }
}

function* createVideoListingSaga(action) {
    const { formData } = action
    const response = yield call(api.createVideoListing, formData)

    if (response.ok) {
        yield put(ListingsActions.createVideoListingSuccess(response))
    } else {
        yield put(ListingsActions.createVideoListingFailure(response.problem))
    }
}

function* createListingWithVideoUrlSaga(action) {
    const { payload } = action
    const response = yield call(api.createListingWithVideoUrl, payload)

    if (response.ok) {
        yield put(ListingsActions.createListingWithVideoUrlSuccess(response.data))
    } else {
        yield put(ListingsActions.createListingWithVideoUrlFailure(response.problem))
    }
}

function* getUserListingsSaga(action) {
    const { options } = action;

    const response = yield call(api.getUserListings, options)

    if (response.ok) {
        yield put(ListingsActions.userListingsSuccess(response.data))
    } else {
        yield put(ListingsActions.fetchingUserListingsFailure(response.problem))
    }
}

function* getAgentListingsSaga(action) {
    const { agentId, options, isPublic } = action;

    const response = yield call(isPublic ? api.publicGetAgentListings : api.getAgentListings, agentId, options)

    if (response.ok) {
        yield put(ListingsActions.agentListingsSuccess(response.data))
    } else {
        yield put(ListingsActions.fetchingAgentListingsFailure(response.problem))
    }
}

function* getAllListingsSaga(action) {
    const { options } = action;
    const response = yield call(api.getAllListings, options)

    if (response.ok) {
        yield put(ListingsActions.fetchingAllListingsSuccess(response.data))
    } else {
        yield put(ListingsActions.fetchingAllListingsFailure(response.problem))
    }
}

function* getSingleListingSaga(action) {
    const { id } = action;
    const response = yield call(api.getSingleListing, id)

    if (response.ok) {
        yield put(ListingsActions.fetchingSingleListingSuccess(response.data))
    } else {
        yield put(ListingsActions.fetchingSingleListingFailure(response.problem))
    }
}

function* updateListingVacancy(action) {
    const { listingId, vacancy, tillWhenDate } = action;
    const response = yield call(api.updateVacancy, listingId, vacancy, tillWhenDate)

    if (response.ok) {
        yield put(ListingsActions.updatingListingVacancySuccess(response.data))
    } else {
        yield put(ListingsActions.updatingListingVacancyFailure(response.problem))
    }
}

function* updateListingPrice(action) {
    const { listingId, price } = action;
    const response = yield call(api.updateListingPrice, listingId, price)

    if (response.ok) {
        yield put(ListingsActions.updatingListingPriceSuccess(response.data))
    } else {
        yield put(ListingsActions.updatingListingPriceFailure(response.problem))
    }
}

function* updateAvailableRooms(action) {
    const { listingId, availableRooms } = action;
    const response = yield call(api.updateAvailableRooms, listingId, availableRooms)

    if (response.ok) {
        yield put(ListingsActions.updatingAvailableRoomsSuccess(response.data))
    } else {
        yield put(ListingsActions.updatingAvailableRoomsFailure(response.problem))
    }
}

function* updateListingUnitVacancy(action) {
    const { listingId, unitId, vacancy, tillWhenDate } = action;
    const response = yield call(api.updateUnitVacancy, listingId, unitId, vacancy, tillWhenDate)

    if (response.ok) {
        yield put(ListingsActions.updatingUnitVacancySuccess(response.data))
    } else {
        yield put(ListingsActions.updatingUnitVacancyFailure(response.problem))
    }
}

function* updateListingUnitPrice(action) {
    const { listingId, unitId, price } = action;
    const response = yield call(api.updateUnitPrice, listingId, unitId, price)

    if (response.ok) {
        yield put(ListingsActions.updatingUnitPriceSuccess(response.data))
    } else {
        yield put(ListingsActions.updatingUnitPriceFailure(response.problem))
    }
}

function* searchListings(action) {
    const { query, filters, page, size, isPublic } = action;
    const response = yield call(isPublic ? api.publicSearchResults : api.searchResults, query, filters, page, size)

    if (response.ok) {
        yield put(ListingsActions.searchingListingsSuccess(response.data))
    } else {
        yield put(ListingsActions.searchingListingsFailure(response.problem))
    }
}

function* searchAgentDataListings(action) {
    const { agentId, query, filters, page, size, isPublic } = action;
    const response = yield call(isPublic ? api.publicSearchAgentListings : api.searcWithinAgentListings, agentId, query, filters, page, size)

    if (response.ok) {
        yield put(ListingsActions.searchingAgentDataListingsSuccess(response.data))
    } else {
        yield put(ListingsActions.searchingAgentDataListingsFailure(response.problem))
    }
}

function* uploadStatusUpdate(action) {
    const { jobId } = action;
    const response = yield call(api.uploadVideoStatus, jobId)

    if (response.ok) {
        yield put(ListingsActions.uploadStatusSuccess(response.data))
    } else {
        yield put(ListingsActions.uploadStatusFailure(response.problem))
    }
}

function* presignVideoSaga(action) {
    const { file, ...formFields } = action.payload

    const presignResponse = yield call(api.presignVideo)
    if (!presignResponse.ok) {
        yield put(ListingsActions.presignVideoFailure(presignResponse.problem || 'Failed to get upload URL'))
        return
    }

    const { uploadUrl, s3Key } = presignResponse.data

    try {
        const s3Response = yield call(fetch, uploadUrl, {
            method: 'PUT',
            body: file,
            headers: { 'Content-Type': 'video/mp4' },
        })
        if (!s3Response.ok) {
            yield put(ListingsActions.presignVideoFailure('Video upload to server failed'))
            return
        }
    } catch (error) {
        yield put(ListingsActions.presignVideoFailure(error.message || 'Video upload failed'))
        return
    }

    yield put(ListingsActions.presignVideoSuccess({ s3Key }))

    const formData = new FormData()
    formData.append('s3Key', s3Key)
    Object.entries(formFields).forEach(([key, value]) => {
        if (value != null) formData.append(key, value)
    })

    yield put(ListingsActions.createVideoListingRequest(formData))
}



export function* searchListingsByDateRange(action) {
    const { vacancy, tillWhenDateFrom, tillWhenDateTo, page, size } = action;
    const response = yield call(api.searchListingsByDateRange, vacancy, tillWhenDateFrom, tillWhenDateTo, page, size)

    if (response.ok) {
        yield put(ListingsActions.searchingListingsByDateRangeSuccess(response.data))
    } else {
        yield put(ListingsActions.searchingListingsByDateRangeFailure(response.problem))
    }
}

function* uploadListingVideoSaga(action) {
    const { listingId, s3Key, title } = action
    const response = yield call(api.uploadListingVideo, listingId, s3Key, title)

    if (response.ok) {
        yield put(ListingsActions.uploadListingVideoSuccess(response.data))
    } else {
        yield put(ListingsActions.uploadListingVideoFailure(response.problem))
    }
}

export function createUploadChannel(uploadUrl, file) {
    return eventChannel((emitter) => {
        const xhr = new XMLHttpRequest()
        xhr.open('PUT', uploadUrl)
        xhr.setRequestHeader('Content-Type', file.type || 'video/mp4')

        xhr.upload.onprogress = (e) => {
            if (e.lengthComputable) {
                const percent = Math.round((e.loaded / e.total) * 100)
                emitter({ type: 'progress', percent })
            }
        }

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                emitter({ type: 'success' })
                emitter(END)
            } else {
                emitter({ type: 'error', message: 'Video upload to S3 failed' })
                emitter(END)
            }
        }

        xhr.onerror = () => {
            emitter({ type: 'error', message: 'Video upload failed' })
            emitter(END)
        }

        xhr.send(file)

        return () => xhr.abort()
    })
}

function* updateListingVideoFileSaga(action) {
    const { listingId, file, title } = action

    const presignResponse = yield call(api.presignVideo)
    if (!presignResponse.ok) {
        yield put(ListingsActions.uploadListingVideoFailure(presignResponse.problem || 'Failed to get upload URL'))
        return
    }

    const { uploadUrl, s3Key } = presignResponse.data

    const channel = yield call(createUploadChannel, uploadUrl, file)

    try {
        while (true) {
            const event = yield take(channel)
            if (event.type === 'progress') {
                yield put(ListingsActions.updateListingVideoProgress(event.percent))
            } else if (event.type === 'success') {
                break
            } else if (event.type === 'error') {
                yield put(ListingsActions.uploadListingVideoFailure(event.message))
                return
            }
        }
    } finally {
        channel.close()
    }

    const response = yield call(api.uploadListingVideo, listingId, s3Key, title)

    if (response.ok) {
        yield put(ListingsActions.uploadListingVideoSuccess(response.data))
    } else {
        yield put(ListingsActions.uploadListingVideoFailure(response.problem))
    }
}

function* updateListingVideoUrlSaga(action) {
    const { listingId, videoUrl } = action
    const response = yield call(api.updateListingVideoUrl, listingId, videoUrl)

    if (response.ok) {
        yield put(ListingsActions.updateListingVideoUrlSuccess(response.data))
    } else {
        yield put(ListingsActions.updateListingVideoUrlFailure(response.problem))
    }
}

export default function* listingsSaga() {
        yield takeLatest(ListingsTypes.CREATE_LISTING_REQUEST, createListingSaga),
        yield takeLatest(ListingsTypes.CREATE_VIDEO_LISTING_REQUEST, createVideoListingSaga),
        yield takeLatest(ListingsTypes.CREATE_LISTING_WITH_VIDEO_URL_REQUEST, createListingWithVideoUrlSaga),
        yield takeLatest(ListingsTypes.PRESIGN_VIDEO_REQUEST, presignVideoSaga),
        yield takeLatest(ListingsTypes.FETCHING_USER_LISTINGS_REQUEST, getUserListingsSaga),
        yield takeLatest(ListingsTypes.FETCHING_AGENT_LISTINGS_REQUEST, getAgentListingsSaga),
        yield takeLatest(ListingsTypes.FETCHING_ALL_LISTINGS_REQUEST, getAllListingsSaga),
        yield takeLatest(ListingsTypes.UPDATING_LISTING_VACANCY_REQUEST, updateListingVacancy),
        yield takeLatest(ListingsTypes.UPDATING_LISTING_PRICE_REQUEST, updateListingPrice),
        yield takeLatest(ListingsTypes.UPDATING_AVAILABLE_ROOMS_REQUEST, updateAvailableRooms),
        yield takeLatest(ListingsTypes.UPDATING_UNIT_VACANCY_REQUEST, updateListingUnitVacancy),
        yield takeLatest(ListingsTypes.UPDATING_UNIT_PRICE_REQUEST, updateListingUnitPrice),
        yield takeLatest(ListingsTypes.SEARCHING_LISTINGS_REQUEST, searchListings),
        yield takeLatest(ListingsTypes.SEARCHING_AGENT_DATA_LISTINGS_REQUEST, searchAgentDataListings),
        yield takeLatest(ListingsTypes.SEARCHING_LISTINGS_BY_DATE_RANGE_REQUEST, searchListingsByDateRange),
        yield takeLatest(ListingsTypes.UPLOAD_LISTING_VIDEO_REQUEST, uploadListingVideoSaga),
        yield takeLatest(ListingsTypes.UPDATE_LISTING_VIDEO_FILE_REQUEST, updateListingVideoFileSaga),
        yield takeLatest(ListingsTypes.UPDATE_LISTING_VIDEO_URL_REQUEST, updateListingVideoUrlSaga),
        yield takeLatest(ListingsTypes.UPLOAD_STATUS_REQUEST, uploadStatusUpdate),
        yield takeLatest(ListingsTypes.FETCHING_SINGLE_LISTING_REQUEST, getSingleListingSaga)

}